
import { defineComponent } from 'vue'
import { subpages } from '@/data/navigation/subpages'
import { supportedLanguages, SupportedLanguage } from '@/scripts/root/language'

interface Subpage {
  text: string
  links?: Record<SupportedLanguage, string>
}

export default defineComponent({
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
  },
  methods: {
    getStoreLink(store: 'appStore' | 'googlePlay'): string {
      const subpage = subpages.find((item: Subpage) => item.text === store) as
        | Subpage
        | undefined

      if (
        subpage?.links &&
        supportedLanguages.includes(this.currentLanguage as SupportedLanguage)
      ) {
        return subpage.links[this.currentLanguage as SupportedLanguage]
      }

      return '#'
    },
  },
})
